<template>
  <div class="footer overflow-y-hidden">
    <div
      class="row align-center animated fadeInUp wow"
      data-wow-delay="300ms"
      data-wow-duration="1s"
      data-wow-offset="100"
    >
      <div class="column small-12 medium-5 large-6 footer__adres">
        Prowadzę kursy w dogodnej lokalizacji w Jaworznie (adres poniżej), a także oferuję dojazd do klienta.
        <hr />
        <h6>ADRES</h6>
        <br />Wapienna 3/1
        <br />43-600, Jaworzno
        <br />Telefon: +48 511 318 138
        <br />
        <br />E-mail: skorzystaj z formularza obok
      </div>

      <div class="column small-12 medium-5 large-6">
        <form @submit="onSubmit">
          <input class="required" type="text" placeholder="Imię:" v-model="name" name="name" />
          <input
            class="required"
            type="text"
            placeholder="E-mail * :"
            v-model="email"
            name="email"
            @keyup="validate"
          />
          <input class="required" type="text" placeholder="Telefon:" v-model="phone" name="phone" />
          <textarea
            class="required"
            cols="30"
            rows="8"
            placeholder="Wiadomość * :"
            v-model="message"
            name="message"
            @keyup="validate"
          ></textarea>
          <button class="button large primary">WYŚLIJ</button>
        </form>
      </div>
    </div>

    <div class="socket">
      <span
        class="animated wow fadeIn"
        data-wow-delay="500ms"
        data-wow-duration="1s"
        data-wow-offset="-50"
      >ANGIELSKI JAWORZNO - {{year}}</span>
    </div>

    <div
      class="bigBlack"
      v-if="formSuccess || formError"
      @click="formSuccess = false; formError = false"
    >
      <div class="formSuccess callout success" v-if="formSuccess" @click.stop>
        <h4>Dziękujemy za wysłanie wiadomości</h4>
        <button class="button success" @click="formSuccess=false">OK</button>
      </div>
      <div class="formError callout alert" v-if="formError" @click.stop>
        <h4>Wypełnij poprawnie wymagane pola</h4>
        <button class="button alert" @click="formError=false">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      message: '',
      year: new Date().getFullYear(),
      formSuccess: false,
      formError: false
    }
  },
  methods: {
    validate(e) {
      const patterns = {
        name: /^[\w]{2,50}$/i,
        message: /^.{5,500}$/gim,
        email: /^([a-z\d.-]+)@([a-z\d-]+)\.([a-z]{2,8})(\.[a-z]{2,8})?$/
      }
      patterns[e.target.name].test(e.target.value)
        ? e.target.classList.remove('invalidValue')
        : e.target.classList.add('invalidValue')
    },
    onSubmit(e) {
      e.preventDefault()
      let valid = false
      let inputsRequired = document.querySelectorAll(
        'input.required, textarea.required'
      )
      let event = document.createEvent('Event')

      inputsRequired.forEach(elem => {
        event.initEvent('keyup', true, true)
        elem.dispatchEvent(event)
      })
      const inputsRequiredArray = Array.apply(null, inputsRequired)
      inputsRequiredArray.some(elem => elem.classList.contains('invalidValue'))
        ? (this.formError = true)
        : (valid = true)
      if (valid) {
        fetch(`https://us-central1-angielski-jaworzno.cloudfunctions.net/sendMail?senderemail=${this.email}&name=${this.name}&phone=${this.phone}&message=${this.message}`)
          .then(resp => resp.text())
          .then(resp => {
            if(resp=='success'){
              this.name = ''
              this.email = ''
              this.phone = ''
              this.message = ''
              this.formSuccess = true
            } else {
              alert(resp)
            }
          })
        
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../myVariables.scss';

.socket {
  height: 40px;
  background: $secondary-color;
  width: 100vw;
  max-width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #a5a49e;
  font-size: 14px;
}
.footer {
  color: white;
  padding: 50px 0 65px;
  background: #515151;
  position: relative;
}
textarea,
input {
  background: #58595b;
  border: 1px solid #9c9c9c;
  padding: 10px 25px;
  font-weight: bold;
  font-size: 16px;
  font-style: italic;
  letter-spacing: -1px;
  color: white;
  resize: none;
  margin-bottom: 20px;
}
input:focus,
textarea:focus {
  background: #58595b;
}
.invalidValue {
  background: #714848 !important;
}
button {
  color: white !important;
  font-family: 'Roboto', sans-serif;
  padding-left: 40px;
  padding-right: 40px;
  margin-top: 10px;
}
form {
  text-align: right;
}
.footer__adres {
  font-size: 14px;
  margin-bottom: 60px;
}
.bigBlack {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  max-width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.54);
  display: flex;
  justify-content: center;
  align-items: center;
}
.formSuccess,
.formError {
  background: white;
  color: $secondary-color;
  animation-name: fadeIn;
  animation-duration: 300ms;
  margin: 0 20px 20px;
  padding: 40px 30px;

  @media (max-width: map-get($breakpoints , medium) - 1) {
    padding: 25px 30px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
